(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["avenue-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('avenue-size-guide')) {
    customElements.define('avenue-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.trigger = this.querySelector('.avenue-guide__trigger');
        this.dialog = this.querySelector('dialog');
        this.trigger.addEventListener('click', (event) => {
          event.stopPropagation();
          if (this.dialog.open) return;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
        });
        this.querySelector('.avenue-guide__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.reset());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.querySelectorAll('.avenue-guide__zoom').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            const figure = button.closest('figure');
            const zoomed = figure.classList.toggle('is-zoomed');
            button.setAttribute('aria-pressed', String(zoomed));
            figure.querySelector('.avenue-guide__image-scroll').scrollLeft = 0;
          });
        });
      }
      reset() {
        if (this.previousOverflow !== undefined) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        this.trigger.setAttribute('aria-expanded', 'false');
        this.querySelectorAll('.avenue-guide__figure').forEach((figure) => {
          figure.classList.remove('is-zoomed');
          figure.querySelector('.avenue-guide__zoom').setAttribute('aria-pressed', 'false');
        });
        if (this.isConnected) this.trigger.focus({preventScroll: true});
      }
      disconnectedCallback() {
        if (this.dialog?.open) { this.dialog.close(); this.reset(); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
